import React from "react";
import { Box, Container, styled, Stack } from "@mui/material";
import FrameworksTitle from "./FrameworksTitle";

// images
// import sliderImg from "../../../assets/images/landingpage/background/slider2.svg";
// import sliderImg2 from "../../../assets/images/landingpage/background/slider-group.png";
import Image from "../../../utils/Image";

const SliderBox = styled(Box)(() => ({
  "@keyframes slide": {
    "0%": {
      transform: "translate3d(0, 0, 0)",
    },
    "100% ": {
      transform: "translate3d(-100%, 0, 0)",
    },
  },
  animation: "slide 45s linear infinite",
}));

const Frameworks = () => {
  return (
    <Box
      bgcolor="action.hover"
      sx={{
        py: {
          xs: "70px",
          lg: "120px",
        },
      }}
    >
      <Container maxWidth="lg">
        {/* Title */}
        <FrameworksTitle />
      </Container>
      <Stack overflow="hidden" mt={6} direction={"row"} spacing={1}>
        <Box>
          <SliderBox>
            {/* <Image src={sliderImg} alt="slide" width="2877" height="956" style={{ height: "100%" }} /> */}
            <Image src={'https://familygeeks.com/members/wp-content/uploads/2023/08/slider2.svg'} alt="slide" width="2877" height="956" style={{ height: "100%" }} />
          </SliderBox>
        </Box>
        <Box>
          <SliderBox>
            {/* <Image src={sliderImg} alt="slide" width="2877" height="956" style={{ height: "100%" }} /> */}
            <Image src={'https://familygeeks.com/members/wp-content/uploads/2023/08/slider2.svg'} alt="slide" width="2877" height="956" style={{ height: "100%" }} />
          </SliderBox>
        </Box>
      </Stack>
    </Box>
  );
};

export default Frameworks;
